module.exports = __webpack_public_path__ + "img/puberty-decal-10.9fab7f8b.png";